import {
  CancellationWaitlistEntryTier,
  CancellationWaitlistNotifyMode,
  CancellationWaitlistTimeOfDay,
} from '@prisma/client';

export const WAITLIST_TIER_LABEL: Record<
  CancellationWaitlistEntryTier,
  string
> = {
  ACCEPTED_REQUEST: 'Accepted request',
  SCHEDULED_EARLIER: 'Scheduled',
  UNATTACHED: 'No appointment',
  BOOKS_REOPENED: 'Books reopened',
};

export const WAITLIST_NOTIFY_MODE_LABELS: Record<
  CancellationWaitlistNotifyMode,
  string
> = {
  INSTANT_ALL: 'Notify everyone at once',
  STAGGERED: 'Stagger notifications',
};

export const WAITLIST_DAY_LABELS = [
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
];

export const WAITLIST_TIME_LABELS: Record<
  CancellationWaitlistTimeOfDay,
  string
> = {
  MORNING: 'Morning',
  AFTERNOON: 'Afternoon',
  EVENING: 'Evening',
};
